import API, { apiErrorMessage } from "../global/api";
import { listPaging } from "../global/Utils";
import { get } from "lodash";
import { addingCompanyForMeCall, deletingCompanyForMeCall } from "./HeaderAction";

// Add Company
export const addCompanyRequest = () => {
  return {
    type: "ADD_COMPANY_REQUEST",
  };
};
export const addCompanySuccess = (data) => {
  return {
    type: "ADD_COMPANY_SUCCESS",
    payload: data,
  };
};
export const addCompanyError = (msg) => {
  return {
    type: "ADD_COMPANY_ERROR",
    payload: msg,
  };
};
export const addCompany = (
  data,
  setFormData,
  setFile,
  handleVisible,
  handleDangerVisible,
) => {
  return (dispatch) => {
    dispatch(addCompanyRequest());
    API.post(`/company/add-company`, data)
      .then((res) => {
        let data1 = res.data;
        dispatch(addCompanySuccess(data1));
        dispatch(addingCompanyForMeCall());
        handleVisible(res.data.message);
        setFormData({
          companyName: "",
          CEOName: "",
          CEOContact: "",
          CEOLandline: "",
          website: "",
          ntn: "",
          cnic: "",
          salesTaxRegNo: "",
          posId: "",
          registrationType: "",
          businessAddress: "",
          province: "",
          GSection236HRegister: "",
          GSection236HNonRegister: "",
          logo: null,
          invoicePattern: "Default",
          concatSerialWithProductName: "No",
          furtherTaxApplicable: "No",
          termsHeading: "",
          termsText: "",
          sandBoxToken: "",
          productiontoken: "",
          userId: "",
          assignedScenarios: [],
        });
        setFile(null);
      })
      .catch((error) => {
        dispatch(addCompanyError(apiErrorMessage(error)));
        handleDangerVisible(apiErrorMessage(error));
      });
  };
};

// Getting Company List
export const getCompanyRequest = () => {
  return {
    type: "COMPANY_LIST_REQUEST",
  };
};
export const getCompanySuccess = (data) => {
  return {
    type: "COMPANY_LIST_SUCCESS",
    payload: data,
  };
};
export const getCompanyError = (msg) => {
  return {
    type: "COMPANY_LIST_ERROR",
    payload: msg,
  };
};
export const getCompany = (page, limit, serachTerm) => {
  return (dispatch) => {
    dispatch(getCompanyRequest());
    const paging = listPaging(page, limit);
    API.get(
      `/company/get-company?page=${paging.page}&limit=${paging.limit}&search=${serachTerm}`,
    )
      .then((res) => {
        let companyList = res.data;
        dispatch(getCompanySuccess(companyList));
      })
      .catch((error) => {
        dispatch(getCompanyError(apiErrorMessage(error)));
      });
  };
};

// Updating Company
export const updateCompanyRequest = () => {
  return {
    type: "UPDATE_COMPANY_LIST_REQUEST",
  };
};
export const updateCompanySuccess = (data) => {
  return {
    type: "UPDATE_COMPANY_LIST_SUCCESS",
    payload: data,
  };
};
export const updateCompanyError = (msg) => {
  return {
    type: "UPDATE_COMPANY_LIST_ERROR",
    payload: msg,
  };
};
export const updateCompany = (
  id,
  data,
  handleVisible,
  handleDangerVisible,
  navigate,
  fromList = false,
  page = "",
  limit = "",
  searchTerm = "",
) => {
  return (dispatch) => {
    dispatch(updateCompanyRequest());
    API.put(`/company/update-company/${id}`, data)
      .then((res) => {
        let updateCompanyList = res.data;
        dispatch(updateCompanySuccess(updateCompanyList));
        handleVisible(res.data.message);
        if (fromList) {
          navigate();
          dispatch(getCompany(page, limit, searchTerm));
        }
        navigate("/main/view-company-list");
      })
      .catch((error) => {
        dispatch(updateCompanyError(apiErrorMessage(error)));
        handleDangerVisible(apiErrorMessage(error));
      });
  };
};

// Deleting Company
export const deleteCompanyRequest = () => {
  return {
    type: "DELETE_COMPANY_LIST_REQUEST",
  };
};
export const deleteCompanySuccess = (data) => {
  return {
    type: "DELETE_COMPANY_LIST_SUCCESS",
    payload: data,
  };
};
export const deleteCompanyError = (msg) => {
  return {
    type: "DELETE_COMPANY_LIST_ERROR",
    payload: msg,
  };
};
export const deleteCompany = (
  id,
  handleVisible,
  handleDangerVisible,
  page,
  limit,
  searchTerm,
) => {
  return (dispatch) => {
    dispatch(deleteCompanyRequest());
    API.delete(`/company/delete-company/${id}`)
      .then((res) => {
        let deleteCompanyList = res.data;
        dispatch(deleteCompanySuccess(deleteCompanyList));
        dispatch(deletingCompanyForMeCall());
        dispatch(getCompany(page, limit, searchTerm));
        handleVisible(res.data.message);
      })
      .catch((error) => {
        dispatch(deleteCompanyError(apiErrorMessage(error)));
        handleDangerVisible(apiErrorMessage(error));
      });
  };
};

// Get Province List
export const getProvinceRequest = () => {
  return {
    type: "PROVINCE_LIST_REQUEST",
  };
};
export const getProvinceSuccess = (data) => {
  return {
    type: "PROVINCE_LIST_SUCCESS",
    payload: data,
  };
};
export const getProvinceError = (msg) => {
  return {
    type: "PROVINCE_LIST_ERROR",
    payload: msg,
  };
};
export const getProvince = () => {
  return (dispatch) => {
    dispatch(getProvinceRequest());
    API.get(`/invoice/get-provinces`)
      .then((res) => {
        let provinceList = res.data;
        dispatch(getProvinceSuccess(provinceList));
      })
      .catch((error) => {
        dispatch(getProvinceError(apiErrorMessage(error)));
      });
  };
};

// Getting Integration Status List
export const getIntegrationStatusRequest = () => {
  return {
    type: "INTEGRATION_STATUS_REQUEST",
  };
};
export const getIntegrationStatusSuccess = (data) => {
  return {
    type: "INTEGRATION_STATUS_SUCCESS",
    payload: data,
  };
};
export const getIntegrationStatusError = (msg) => {
  return {
    type: "INTEGRATION_STATUS_ERROR",
    payload: msg,
  };
};
export const getIntegrationStatus = () => {
  return (dispatch) => {
    dispatch(getIntegrationStatusRequest());
    API.get(`/company/company-integration-status`)
      .then((res) => {
        let integrationStatusList = res.data;
        dispatch(getIntegrationStatusSuccess(integrationStatusList));
      })
      .catch((error) => {
        dispatch(getIntegrationStatusError(apiErrorMessage(error)));
      });
  };
};

// Change Integration Status
export const changeIntegrationStatusOfCompanyRequest = () => {
  return {
    type: "UPDATE_COMPANY_INTEGRATION_STATUS_REQUEST",
  };
};
export const changeIntegrationStatusOfCompanySuccess = (data) => {
  return {
    type: "UPDATE_COMPANY_INTEGRATION_STATUS_SUCCESS",
    payload: data,
  };
};
export const changeIntegrationStatusOfCompanyError = (msg) => {
  return {
    type: "UPDATE_COMPANY_INTEGRATION_STATUS_ERROR",
    payload: msg,
  };
};
export const changeIntegrationStatusOfCompany = (
  id,
  data,
  handleVisible,
  handleDangerVisible,
  onClose,
  page = "",
  limit = "",
  searchTerm = "",
) => {
  return (dispatch) => {
    dispatch(changeIntegrationStatusOfCompanyRequest());
    API.put(`/company/update-company-integration-status/${id}`, data)
      .then((res) => {
        let updateIntegrationStatusOfCompanyList = res.data;
        dispatch(
          changeIntegrationStatusOfCompanySuccess(
            updateIntegrationStatusOfCompanyList,
          ),
        );
        handleVisible(updateIntegrationStatusOfCompanyList.message);
        onClose();
        dispatch(getCompany(page, limit, searchTerm));
      })
      .catch((error) => {
        dispatch(
          changeIntegrationStatusOfCompanyError(apiErrorMessage(error)),
        );
        handleDangerVisible(apiErrorMessage(error));
      });
  };
};

// Uploading the Document
export const requestUploadDocument = () => {
  return {
    type: "REQUEST_UPLOAD_DOCUMENT",
  };
};
export const successUploadDocument = (data) => {
  return {
    type: "SUCCESS_UPLOAD_DOCUMENT",
    payload: data,
  };
};
export const errorUploadDocument = (msg) => {
  return {
    type: "ERROR_UPLOAD_DOCUMENT",
    payload: msg,
  };
};
export const uploadDocument = (
  data,
  handleDangerVisible,
  setFormData,
  setFile,
) => {
  const formData = new FormData();
  formData.append("image", get(data, "image"));
  return (dispatch) => {
    dispatch(requestUploadDocument());
    API.post(`/files/image`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
      .then((res) => {
        let uploadDetails = res.data;
        dispatch(successUploadDocument(uploadDetails));
        setFormData((prev) => ({
          ...prev,
          logo: uploadDetails.file,
        }));
        setFile(data.image);
      })
      .catch((error) => {
        dispatch(errorUploadDocument(apiErrorMessage(error)));
        handleDangerVisible(apiErrorMessage(error));
        setFile(null);
      });
  };
};

// Is getting CompanyDetails
export const getCompanyDetailsRequest = () => {
  return {
    type: "GET_COMPANY_DETAILS_REQUEST",
  };
};
export const getCompanyDetailsSuccess = (data) => {
  return {
    type: "GET_COMPANY_DETAILS_SUCCESS",
    payload: data,
  };
};
export const getCompanyDetailsError = (msg) => {
  return {
    type: "GET_COMPANY_DETAILS_ERROR",
    payload: msg,
  };
};
export const getCompanyDetails = (id, handleDangerVisibleForCompanyDetails) => {
  return (dispatch) => {
    dispatch(getCompanyDetailsRequest());
    API.get(`/company/get-company-with-Id/${id}`)
      .then((res) => {
        let getCompanyViewDetails = res.data;
        dispatch(getCompanyDetailsSuccess(getCompanyViewDetails));
      })
      .catch((error) => {
        dispatch(getCompanyDetailsError(error?.response?.data?.message || ""));
        if (id) {
          handleDangerVisibleForCompanyDetails();
        }
      });
  };
};